document.addEventListener("DOMContentLoaded", () => {
  let wishlist   = JSON.parse(localStorage.getItem("wishlist")) || [];
  const container = document.getElementById("wishlist-items");
  const emptyText = document.getElementById("wishlist-empty");
  const clearBtn  = document.getElementById("clear-wishlist");
  const addAllBtn = document.getElementById("wishlist-add-all");

  // Update Dawn cart icon bubble (#cart-icon-bubble)
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;

      const cart = await res.json();

      const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (!bubble) return;

      const visible = bubble.querySelector('span[aria-hidden="true"]');
      if (visible) {
        visible.textContent = cart.item_count;
      }

      const hidden = bubble.querySelector('.visually-hidden');
      if (hidden) {
        hidden.textContent = `${cart.item_count} items`;
      }
    } catch (e) {
      console.error('Error refreshing cart count', e);
    }
  }

  if (!container || !emptyText || !clearBtn) return;

  // Empty-state handling
  if (wishlist.length === 0) {
    emptyText.style.display = "block";
    clearBtn.style.display = "none";
    if (addAllBtn) addAllBtn.style.display = "none";
    return;
  }

  emptyText.style.display = "none";
  clearBtn.style.display = "inline-block";
  if (addAllBtn) addAllBtn.style.display = "inline-block";

  // Clear handler
  clearBtn.addEventListener("click", () => {
    localStorage.removeItem("wishlist");
    location.reload();
  });

  // Render each wishlist item
  wishlist.forEach(item => {
    const handle    = typeof item === "string" ? item : item.handle;
    const variantId = typeof item === "string" ? null  : item.variantId;

    fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        let url          = `/products/${product.handle}`;
        let price        = product.price;
        let image        = product.featured_image;
        let variantLabel = "";

        if (variantId) {
          const variant = product.variants.find(v => String(v.id) === String(variantId));
          if (variant) {
            url   = `/products/${product.handle}?variant=${variant.id}`;
            price = variant.price;

            const isDefaultVariantTitle = variant.title === "Default Title";
            if (!isDefaultVariantTitle) {
              const parts = [];
              if (variant.option1) parts.push(variant.option1);
              if (variant.option2) parts.push(variant.option2);
              if (variant.option3) parts.push(variant.option3);
              variantLabel = parts.join(" / ");
            }

            if (variant.featured_image && variant.featured_image.src) {
              image = variant.featured_image.src;
            } else if (product.images && product.images.length > 0) {
              image = product.images[0];
            }
          }
        }

        const effectiveVariantId =
          variantId ||
          (product.variants && product.variants[0] ? product.variants[0].id : null);

        const priceText = (price / 100).toLocaleString("en-US", {
          style: "currency",
          currency: "USD"
        });

        const productHTML = `
  <div class="wishlist-card">
    <a href="${url}">
      <img src="${image}" alt="${product.title}" class="wishlist-product-img">
      <h3>${product.title}</h3>
      ${variantLabel ? `<p>${variantLabel}</p>` : ""}
      <p>${priceText}</p>
    </a>

    <div class="wishlist-card__actions">
      <button
        class="button wishlist-add-to-cart"
        data-variant-id="${effectiveVariantId || ''}"
        aria-label="Add to cart"
      >
        <!-- Cart icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="wishlist-button-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="9" cy="21" r="1.4"></circle>
          <circle cx="19" cy="21" r="1.4"></circle>
          <path d="M3 3h2l2 13h12"></path>
          <path d="M7 6h14l-1.5 7H9"></path>
        </svg>
      </button>

      <button
        class="button remove-wishlist"
        data-handle="${product.handle}"
        data-variant-id="${variantId || ''}"
        aria-label="Remove from wishlist"
      >
        <!-- Trash icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="wishlist-button-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 6h18"></path>
          <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
          <path d="M10 11v7"></path>
          <path d="M14 11v7"></path>
          <path d="M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14"></path>
        </svg>
      </button>
    </div>
  </div>
`;


        container.insertAdjacentHTML("beforeend", productHTML);
      });
  });

  // Remove single item handler
  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("remove-wishlist")) {
      const handle    = e.target.dataset.handle;
      const variantId = e.target.dataset.variantId;

      wishlist = wishlist.filter(item => {
        if (typeof item === "string") {
          return item !== handle;
        }
        if (variantId) {
          return !(item.handle === handle && String(item.variantId) === String(variantId));
        }
        return item.handle !== handle;
      });

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      location.reload();
    }
  });

  // Single-item Add to cart handler
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".wishlist-add-to-cart");
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!res.ok) {
        console.error("Error adding wishlist item to cart");
      } else {
        await refreshCartCount();   // update bag number
      }
    } catch (err) {
      console.error("Wishlist add-to-cart error:", err);
    } finally {
      btn.disabled = false;
    }
  });

  // Add All to Cart handler
  if (addAllBtn) {
    addAllBtn.addEventListener("click", async () => {
      const currentWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
      if (!currentWishlist.length) return;

      const entries = currentWishlist.map((entry) => {
        if (typeof entry === "string") {
          return { handle: entry, variantId: null };
        }
        return { handle: entry.handle, variantId: entry.variantId || null };
      });

      try {
        const resolved = await Promise.all(
          entries.map(({ handle, variantId }) =>
            fetch(`/products/${handle}.js`)
              .then((res) => res.json())
              .then((product) => {
                let id = variantId;
                if (!id && product.variants && product.variants.length) {
                  id = product.variants[0].id;
                }
                return id ? { id, quantity: 1 } : null;
              })
          )
        );

        const items = resolved.filter(Boolean);
        if (!items.length) return;

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          console.error("Add all to cart error");
          return;
        }

        await refreshCartCount();   // update bag number
        window.location.href = "/cart";
      } catch (error) {
        console.error("Add all to cart error:", error);
      }
    });
  }
});

